import { Component, Inject, OnInit, Optional } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-custom-assign-collectors',
  templateUrl: './custom-assign-collectors.component.html',
  styles: [
    'button {margin-left: 1em}',
    'p {font-weight: bold}'
  ]
})
export class CustomAssignCollectorsComponent implements OnInit {
  constructor(
    private apiService: LegacyApiService,
    public dialogRef: MatDialogRef<CustomAssignCollectorsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {dialogRef.disableClose = true; }

  selectedInputValue: string='';
  collectorNames: any;
  selectedEmpID: any;
  selectedFirstName: any;
  isLock: boolean = false;
  collectorInfo: any;  
  collectorName = new FormControl('', Validators.required);

  ngOnInit(): void {
    this.apiService.getUnderwriters().subscribe((res: any) => {
      this.collectorNames = res?.['data']?.filter((item) => item?.['position'] === 'CO' && item?.['employee_status'] === true);
    })
  }

  selectedCollector(e) {
    this.collectorInfo = {};
    this.selectedEmpID = e.value;
    this.selectedFirstName = e.source.triggerValue?.split(' ')?.[0];
    this.collectorInfo = { empID: this.selectedEmpID, collectorName: this.selectedFirstName };
  }

  onAssign() {
    const acctrefList = this.data.map(({acctrefno})=> acctrefno );
    this.apiService.assignCollectorListInterface('acctrefno', acctrefList, this.collectorInfo, this.isLock).subscribe((res: any) => {
      // console.log(res);
      // console.log(res,"+++++++++++++")
      this.dialogRef.close(true);
    })
  }

  onClose() {
    this.dialogRef.close(false);
  }
  
}
